import React from "react";
import { Form, Input, InputNumber } from "antd";
import style from "./index.module.less";
import {
  checkIsValidNumberOfPassengers,
  checkPostalCode,
  checkURL,
} from "../../../Functions";

const validation = {
  email: {
    required: true,
    type: "email",
    message: "Please enter valid email",
  },
  password: {
    required: true,
    type: "password",
    message: "Please enter valid password",
  },
  vehicleName: {
    required: true,

    message: "Please enter vehicle name",
  },
  name: {
    required: true,

    message: "Please enter your full name",
  },
  vehicleNumber: {
    required: true,

    message: "Please enter vehicle number",
  },
  phone: {
    required: true,

    message: "Please enter phone number",
  },
  shopName: {
    required: true,
    message: "Please enter shop name",
  },
  shopLocation: {
    required: true,
    message: "Please enter shop location",
  },
  address: {
    required: true,
    message: "Please select address using PIN location with map",
  },
  url: {
    required: true,
    message: "Please enter url",
  },
  brand: {
    required: true,
    message: "Please enter brand",
  },
  postal: {
    required: true,
    validator: (_, value) =>
      checkPostalCode(value)
        ? Promise.resolve()
        : Promise.reject(new Error("Please enter valid code")),
  },
  notCompulsory: {
    required: false,
  },
  listingName: {
    required: true,
    message: "Please enter listing name",
  },
  shopAddress: {
    required: true,
    message: "Please pin shop address",
  },
  shopEmail: {
    required: true,
    message: "Please enter shop email",
  },
  shopWebsite: {
    required: true,
    message: "Please enter shop address",
  },
  carName: {
    required: true,
    message: "Please enter car name",
  },
  numberOfPassengers: {
    required: true,
    validator: (_, value) =>
      checkIsValidNumberOfPassengers(value)
        ? Promise.resolve()
        : Promise.reject(
            new Error("Number Of Passenger can't be less than 01")
          ),
  },
  maximunAmount: {
    required: true,
    message: "Please enter amount with in range.",
  },
  brandName: {
    required: true,
    message: "Please enter car's brand name",
  },
  ratesPerDay: {
    required: true,
    message: "Please enter rates",
  },
  vehicleMode: {
    required: true,
    message: "Please select vehicle mode",
  },
  carNumber: {
    required: true,
    message: "Please enter valid vehicle number",
  },
};
export const TextBox = ({
  label,
  placeholder,
  type,
  validationKey,
  name,
  size,
  hasFeedback,
  dependencies,
  className,
  change,
  value,
  disabled,
}) => {
  let validator;
  if (validationKey) {
    validator = validation[validationKey];
  }
  return (
    <Form.Item
      label={label}
      rules={[validator]}
      name={name}
      hasFeedback={hasFeedback}
      dependencies={[dependencies]}
      validateTrigger='onBlur'
      className={style.textBoxWrapper}
      initialValue={value}
    >
      {type !== "password" ? (
        <Input
          disabled={disabled}
          placeholder={placeholder}
          className={className}
          allowClear={type === "search" ? true : false}
          size={size}
          onChange={change || null}
          type={type}
        />
      ) : (
        <Input.Password placeholder={placeholder} />
      )}
    </Form.Item>
  );
};
export const AccordianTextBox = ({ placeholder, disabled, change, icon }) => (
  <Input
    disabled={disabled}
    suffix={icon}
    onChange={change}
    placeholder={placeholder}
    className={style.accordianTextField}
  />
);
export const NumberField = ({
  name,
  validationKey,
  label,
  placeholder,
  value,
  onChange,
  addOnAfter,
  cssClass,
  max,
  min,
}) => {
  const validator = validationKey && validation[validationKey];

  return (
    <Form.Item
      name={name}
      rules={[validator]}
      validateTrigger="onBlur"
      initialValue={value}
      label={label}
    >
      <InputNumber
        min={min}
        max={max}
        addonAfter={addOnAfter}
        onChange={onChange}
        // controls={false}
        placeholder={placeholder}
        className={`${cssClass} ${style.inputNumberField}`}
      />
    </Form.Item>
  );
};
TextBox.defaultProps = {
  type: "text",
  placeholder: "PlaceHolder",
  hasFeedback: false,
  dependencies: "",
  change: "",
  customRule: undefined,
};
